import React, { useEffect, useState } from "react";
import { Routes as Switch, Route, useLocation, Navigate, useNavigate } from "react-router-dom";

import { useRecoilState, useSetRecoilState } from "recoil";
import { userInfo, userCredentials, rioNegroServices, snackbarData } from "./recoilState/GlobalState";

import { getUserCredentials } from "services/getUserCredentials";
import { checkAuth } from "services/checkAuth";
import { usuarioMinimosGet } from "services/services-mia";

import ProtectedRoute from "./components/route/ProtectedRoute";
import { CircularIndeterminate, Header } from "components";
import SnackBar from "components/utils/snackbars/Snackbar";

import {
    Dashboard,
    Usuarios,
    Login,
    UsuariosXServicio,
    UserDetailsDashboard
} from "./pages";

import { Routes as ROUTES } from "./consts/Routes-App";

import ServiceRoute from "components/route/ServiceRoute";
import { merchantLogoGet } from "services/services-mia/merchant";
import { RNServicioGet } from "services/services-mia/RNServicioGet";

import s from "./App.module.scss"
import DespachantesProgramaCalor from "pages/programa-calor/despachantes/index";
import BeneficiariosProgramaCalor from "pages/programa-calor/beneficiarios";
import BeneficiariosEntregaSociales from "pages/entregas-sociales/beneficiarios";
import DespachantesEntregaSociales from "pages/entregas-sociales/despachantes";
import InformesAsisteRN from "pages/entregas-sociales/informes";
import RubosEntregasSociales from "pages/entregas-sociales/rubros";
import ArticulosEntregasSociales from "pages/entregas-sociales/articulos";
import { subscribe, unsubscribe } from "./utils/eventManager.js";
import BeneficiariosNavidad from "pages/programa-navidad/beneficiarios";
import ComerciosNavidad from "pages/programa-navidad/despachantes";
import ProgramasNavidad from "pages/programa-navidad/programas";
import UsuariosGlobales from "pages/usuariosGlobales/beneficiarios";
import InformesProgramaSocial from "pages/programa-navidad/informes";
import ZonasSalud from "pages/programa-salud/zonas";
import AreasSalud from "pages/programa-salud/areas";
import ServiciosSalud from "pages/programa-salud/servicios";
import DepartamentosSalud from "pages/programa-salud/departamentos";
import NivelesSalud from "pages/programa-salud/niveles";
import UnidadesSalud from "pages/programa-salud/unidades";
import TitulosSalud from "pages/programa-salud/titulos";
import HospitalesSalud from "pages/programa-salud/hospitales/Hospitales";
import DivisionesSalud from "pages/programa-salud/divisiones";
import EstructurasSalud from "pages/programa-salud/estructuras";
import ComponentesSecundariosSalud from "pages/programa-salud/componentesSecundarios";

export default function App() {
    const [loading, setLoading] = useState(true);
    const [isAuth, setIsAuth] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [credentials, setCredentials] = useRecoilState(userCredentials);
    const [routeError, setRouteError] = useState(false);
    const [info, setInfo] = useRecoilState(userInfo);
    const setServices = useSetRecoilState(rioNegroServices);
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        (async () => {
            const newCredentials = await getUserCredentials();
            if (newCredentials) {
                setCredentials(newCredentials);
                const userData = await usuarioMinimosGet(newCredentials);
                const { result: merchantData } = await merchantLogoGet({}, newCredentials);
                setInfo({ ...merchantData[0], ...userData });
                const { result: servicesData } = await RNServicioGet({}, newCredentials);

                setServices([...servicesData]);
            }
            setIsAuth(checkAuth());
            setLoading(false);
        })();
    }, [setCredentials, setInfo, setServices]);

    useEffect(() => {
        if (loading) return;
        setIsAuth(checkAuth());
    }, [credentials, loading]);
    useEffect(() => {
        const handleErrorServer = (data) => {
            setSnackBarInfo({
                message: data.message,
                severity: "warning",
                open: true,
            });
        };
        const handleSessionExpired = (data) => {
            console.log("sessionExpired");
            setSnackBarInfo({
                message: data.message,
                severity: "warning",
                open: true,
            });
            setRouteError(ROUTES.login.route);
            navigate(ROUTES.login.route);
            setIsOpen(true);
        };
        subscribe("serverError", handleErrorServer);
        subscribe("sessionExpired", handleSessionExpired);
        return () => {
            unsubscribe("serverError", handleErrorServer);
            unsubscribe("sessionExpired", handleSessionExpired);
        };
    }, []);
    if (loading) return <CircularIndeterminate />;
    return (
        <div className={s.container}>
            <div className={setIsAuth.header}>
                {location.pathname !== ROUTES.login.route && <Header />}

            </div>
            <div className={s.body}>
                <SnackBar />

                <Switch>
                    <Route path={ROUTES.login.route} exact element={<Login />} />

                    <Route
                        element={
                            <ProtectedRoute
                                redirectProtectedRoute={ROUTES.login.route}
                                isAuth={isAuth}
                            />
                        }
                    >
                        <Route
                            path={ROUTES.dashboard.route}
                            exact
                            element={<Dashboard route={ROUTES.dashboard} />}
                        />
                        <Route
                            path={ROUTES.usuarios.route}
                            exact
                            element={<Usuarios route={ROUTES.usuarios} />}
                        />
                        <Route
                            path={"usuarios/:usuarioId/details"}
                            element={<UserDetailsDashboard />}
                        />

                        <Route
                            path="servicio/RNCALOR"
                            element={<ServiceRoute servicioCod="RNCALOR" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route path="beneficiarios" element={<BeneficiariosProgramaCalor />} />
                            <Route path="despachantes" element={<DespachantesProgramaCalor />} />
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />

                        </Route>
                        <Route
                            path="servicio/RNES"
                            element={<ServiceRoute servicioCod="RNES" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route path="beneficiarios" element={<BeneficiariosEntregaSociales />} />
                            <Route path="rubros" element={<RubosEntregasSociales />} />
                            <Route path="articulos" element={<ArticulosEntregasSociales />} />
                            <Route path="despachantes" element={<DespachantesEntregaSociales />} />
                            <Route
                                path="usuarios"
                                element={<UsuariosXServicio />}
                            />
                            <Route
                                path="informes"
                                element={<InformesAsisteRN />}
                            />

                        </Route>
                        <Route
                            path="servicio/RNPSOCIAL"
                            element={<ServiceRoute servicioCod="RNPSOCIAL" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route path="programas" element={<ProgramasNavidad />} />
                            <Route path="beneficiarios" element={<BeneficiariosNavidad />} />
                            <Route path="comercios" element={<ComerciosNavidad />} />
                            <Route path="usuarios" element={<UsuariosXServicio />} />
                            <Route path="informes" element={<InformesProgramaSocial />} />
                        </Route>
                        <Route
                            path="servicio/RNPSALUD"
                            element={<ServiceRoute servicioCod="RNPSOCIAL" redirectProtectedRoute={ROUTES.login.route} />}
                        >
                            <Route path="zonas" element={<ZonasSalud />} />
                            <Route path="areas" element={<AreasSalud />} />
                            <Route path="servicios" element={<ServiciosSalud />} />
                            <Route path="departamentos" element={<DepartamentosSalud />} />
                            <Route path="niveles" element={<NivelesSalud />} />
                            <Route path="unidades" element={<UnidadesSalud />} />
                            <Route path="titulos" element={<TitulosSalud />} />
                            <Route path="hospitales" element={<HospitalesSalud />} />
                            <Route path="divisiones" element={<DivisionesSalud />} />
                            <Route path="componentes-secundarios" element={<ComponentesSecundariosSalud />} />
                            <Route path="estructuras" element={<EstructurasSalud />} />
                        </Route>
                        <Route
                            path={ROUTES.usuariosGlobales.route}
                            exact
                            element={<UsuariosGlobales />}
                        />
                        <Route
                            path="/*"
                            element={<Dashboard />}
                        />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
